module.exports = __webpack_public_path__ + "img/audio.368a3d95.gif";